import { IMappingTextPack, IMap } from "esdm-map";
import { IVectorLayerGroupConfig } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { LhlpRecordType } from "./defs/LhlpRecordType";
import { ILhlpTenantSettingsFactory, LhlpTenantSettings, LhlpTenantSettingsFactory } from "./defs/LhlpTenantSettings";
import { LhlpUser } from "./defs/LhlpUser";


export class MapBase {

    protected tenantSettings: LhlpTenantSettings;

    constructor(    
        protected mappingTextPack: IMappingTextPack,
        protected user: LhlpUser)
    {        
        const tenantSettingsFactory: ILhlpTenantSettingsFactory = new LhlpTenantSettingsFactory();
        this.tenantSettings = tenantSettingsFactory.GetSettings();
        this.setToolbarStyleForTouch();
    }

    protected setToolbarStyleForTouch(): void {    
        //touch test (copied from ol code that adds ol-touch to viewport)
        if ('ontouchstart' in window) {
            let e = $("#mapToolbar");
            if (e[0]) {
                e.addClass("ol-touch");
            }
        }
    }

    protected isAuthenticated = (): boolean => {
        return this.user !== null;
    }

    protected filterMapLayers = (layerGroupConfig: Array<IVectorLayerGroupConfig> ): Array<IVectorLayerGroupConfig> => {
        // if (!this.isAuthenticated()) {
        //     //remove layers that require authentication
        //     return layerGroupConfig.filter(function (value, index, arr) {
        //         let authlayers = (value.type === LhlpRecordType.ASSET_PRIVATE);
        //         return !authlayers;
        //     });
        // } else {
        //     //remove layers that don't require authentication
        //     return layerGroupConfig.filter(function (value, index, arr) {
        //         let authlayers = (value.type === LhlpRecordType.ASSET_PUBLIC);
        //         return !authlayers;
        //     });
        // }
        return layerGroupConfig;
    }  
}